import React from 'react'

import config from '../config.js'

import { Link } from 'react-router-dom'

const ListChapter = ({ cookbookUrl, chapter }) => {
  let recipeImageUrls = []
  let recipeThumbnails = ''
  let recipeCount = 0

  if (chapter.recipes !== undefined && chapter.recipes.length > 0) {
    recipeCount = chapter.recipes.length
  }

  let count = 0
  let index = 0
  while (count < 6) {
    if (index >= recipeCount) {
      recipeImageUrls[count] =
        config.baseUrl + '/assets/img/generic-recipe-small.png'
      count++
    } else if (recipeCount > 0 && chapter.recipes[index].imageUrl != null) {
      recipeImageUrls[count] = chapter.recipes[index].imageUrl + '=s90-c'
      count++
    }
    index++
  }

  recipeThumbnails = recipeImageUrls.map((item, index) => {
    if (item !== undefined) {
      return <img key={index} src={item} alt="" />
    }
    return ''
  })

  return (
    <li className="chapter">
      <div className="chapter__recipe-thumbnails">{recipeThumbnails}</div>
      <h3 className="chapter__title">
        <Link
          className="chapter__link"
          to={cookbookUrl + '/' + chapter.identifier}
        >
          {chapter.title}
        </Link>
      </h3>
      <p className="chapter__recipe-count">
        {chapter.recipesCount}&nbsp;{chapter.recipesCount === undefined
          ? ''
          : chapter.recipesCount > 1
            ? 'Recipes'
            : 'Recipe'}
      </p>
    </li>
  )
}

export default ListChapter



// WEBPACK FOOTER //
// ./src/Components/ListChapter.js